import { api } from '@/shared/services/api';
import {
  CreateFeedItemLinkRequest,
  FeedItemLinkDto,
  UpdateFeedItemLinkRequest,
} from '@/shared/types/api';

/**
 * Useful links attached to a feed item (SC-237 add, SC-275 view/edit, SC-276 delete).
 * Reading is open to any authenticated user; the server rejects an edit or delete from
 * anyone but the link's author or an admin. Mirrors the per-feature module style of
 * adminApi.ts / taskApi.ts.
 */
export const feedItemLinkApi = {
  list: async (feedItemId: number): Promise<FeedItemLinkDto[]> =>
    (await api.get<FeedItemLinkDto[]>(`/feeditemlinks/feeditem/${feedItemId}`)).data,

  create: async (request: CreateFeedItemLinkRequest): Promise<FeedItemLinkDto> =>
    (await api.post<FeedItemLinkDto>('/feeditemlinks', request)).data,

  update: async (id: number, request: UpdateFeedItemLinkRequest): Promise<FeedItemLinkDto> =>
    (await api.put<FeedItemLinkDto>(`/feeditemlinks/${id}`, request)).data,

  remove: async (id: number): Promise<void> => {
    await api.delete(`/feeditemlinks/${id}`);
  },
};
